export type SmartPreferenceBannerVariant = 'partialMatch' | 'onlyPartialMatch'

interface GetSmartPreferenceSectionStateParams<T> {
    preferredEntries?: T[]
    nonPreferredEntries?: T[]
    fallbackEntries: T[]
    isSmartSort: boolean
}

interface SmartPreferenceSectionState<T> {
    primaryEntries: T[]
    secondaryEntries: T[]
    shouldShowSmartPreferenceBanner: boolean
    shouldShowBannerBeforePrimary: boolean
    shouldShowBannerBeforeSecondary: boolean
    bannerVariant: SmartPreferenceBannerVariant
}

export const getSmartPreferenceSectionState = <T>({
    preferredEntries = [],
    nonPreferredEntries = [],
    fallbackEntries,
    isSmartSort
}: GetSmartPreferenceSectionStateParams<T>): SmartPreferenceSectionState<T> => {
    const hasPreferredEntries = preferredEntries.length > 0
    const hasNonPreferredEntries = nonPreferredEntries.length > 0

    const primaryEntries = hasPreferredEntries
        ? preferredEntries
        : hasNonPreferredEntries
            ? nonPreferredEntries
            : fallbackEntries

    return {
        primaryEntries,
        secondaryEntries: hasPreferredEntries ? nonPreferredEntries : [],
        shouldShowSmartPreferenceBanner: isSmartSort && hasNonPreferredEntries,
        shouldShowBannerBeforePrimary: isSmartSort && !hasPreferredEntries && hasNonPreferredEntries,
        shouldShowBannerBeforeSecondary: isSmartSort && hasPreferredEntries && hasNonPreferredEntries,
        bannerVariant: hasPreferredEntries ? 'partialMatch' : 'onlyPartialMatch'
    }
}

